var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSales = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_1478_1258)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.60817 11.6666C5.72151 12.2377 7.00222 12.3924 8.21952 12.1028C9.43682 11.8132 10.5107 11.0983 11.2475 10.0871C11.9844 9.07575 12.3358 7.83453 12.2385 6.58704C12.1412 5.33955 11.6015 4.16784 10.7167 3.28306C9.83194 2.39827 8.66023 1.85859 7.41274 1.76127C6.16526 1.66395 4.92403 2.01539 3.91273 2.75226C2.90144 3.48912 2.18657 4.56296 1.89697 5.78026C1.60736 6.99756 1.76205 8.27828 2.33317 9.39161L1.1665 12.8333L4.60817 11.6666Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_1478_1258)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.6665 7H4.67234",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_1478_1258)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 7H7.00583",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i_1478_1258)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.3335 7H9.33933",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_1478_1258",
  x: 0.666504,
  y: 1.24536,
  width: 13.0879,
  height: 13.0879,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_1478_1258"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_1478_1258",
  x: 4.1665,
  y: 6.5,
  width: 2.00586,
  height: 2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_1478_1258"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_1478_1258",
  x: 6.5,
  y: 6.5,
  width: 2.00586,
  height: 2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_1478_1258"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i_1478_1258",
  x: 8.8335,
  y: 6.5,
  width: 2.00586,
  height: 2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_1478_1258"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSales);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";